module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#logic",
      toString: function () {
        return this.url;
      }
    }